import { PostHogProvider } from "@posthog/react";
import {
  isPostHogEnabled,
  POSTHOG_HOST,
  POSTHOG_PROJECT_TOKEN,
} from "../utils/posthog";
import PostHogPageViewTracker from "./PostHogPageViewTracker";

type PostHogProviderWrapperProps = {
  children: React.ReactNode;
};

const PostHogProviderWrapper = ({ children }: PostHogProviderWrapperProps) => {
  if (!isPostHogEnabled() || !POSTHOG_PROJECT_TOKEN) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider
      apiKey={POSTHOG_PROJECT_TOKEN}
      options={{
        api_host: POSTHOG_HOST,
        // SPA route changes are tracked manually via PostHogPageViewTracker.
        capture_pageview: false,
      }}
    >
      <PostHogPageViewTracker />
      {children}
    </PostHogProvider>
  );
};

export default PostHogProviderWrapper;
